module.exports = __webpack_public_path__ + "img/no-instruments.f646e047.jpg";